module.exports = __webpack_public_path__ + "media/PAG72-05.a51af15a.mp3";